import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export const Footer = () => {
  const { site } = useSite();
  const c = site?.content || {};
  return (
    <footer className="bg-primary text-primary-foreground px-5 sm:px-8 lg:px-12 pt-16 pb-24 lg:pb-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-serif text-3xl">Garage Getaway Beaumont</p>
          <p className="mt-2 text-sm opacity-70">Beaumont, Texas</p>
        </div>
        <div className="text-sm space-y-2">
          <p className="eyebrow !text-[hsl(96_14%_70%)]">Contact</p>
          {c.contact_email && <a href={`mailto:${c.contact_email}`} className="block hover:underline" data-testid="footer-email">{c.contact_email}</a>}
          {c.contact_phone && <a href={`tel:${c.contact_phone}`} className="block hover:underline" data-testid="footer-phone">{c.contact_phone}</a>}
          {!c.contact_email && !c.contact_phone && <p className="opacity-70">Message us through your booking confirmation.</p>}
        </div>
        <div className="text-sm flex flex-col gap-2">
          <p className="eyebrow !text-[hsl(96_14%_70%)]">Policies</p>
          <Link to="/policies/privacy" data-testid="footer-privacy" className="hover:underline">Privacy Policy</Link>
          <Link to="/policies/terms" data-testid="footer-terms" className="hover:underline">Terms of Service</Link>
          <Link to="/policies/cancellation" data-testid="footer-cancellation" className="hover:underline">Cancellation Policy</Link>
          <Link to="/policies/house-rules" data-testid="footer-house-rules" className="hover:underline">House Rules</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/15 text-xs opacity-60 flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} Garage Getaway Beaumont · Beaumont, Texas</span>
        <Link to="/admin" data-testid="footer-owner-login" className="hover:underline">Owner login</Link>
      </div>
    </footer>
  );
};
